import { gql } from 'graphql-request'

export const QueryBlockRequestForm = gql`
  fragment FragmentBlockRequestForm on BlockRequestFormModelRecord {
    __typename
    id
    title
    headingType
    formPosition
    description {
      value
      links {
        ...FragmentLinkReferences
      }
      blocks {
        __typename
        id
        file {
          format
          responsiveImage {
            ...responsiveImageFragment
          }
        }
      }
    }
    hubSpotForm {
      ...FragmentHubspotForm
    }
    bulletPointsText
    anchor
  }
`
export const BlockRequestForm = {
  __typename: 'BlockRequestForm',
  fragmentName: 'FragmentBlockRequestForm',
  fragmentQuery: QueryBlockRequestForm,
  fragments: []
}
